import React from "react";

export const CustomerEssentialsSvg = () => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        overflow="hidden">
        <path d="M8.6,7.2c.2-.4.4-.7.5-1.1.1-.4.2-.8.2-1.3,0-1.3-.4-2.3-1.3-3.2S6.1.2,4.8.2s-2.3.4-3.2,1.3S.3,3.5.3,4.7s.4,2.3,1.3,3.2,1.9,1.3,3.2,1.3.9,0,1.3-.2c.4-.1.8-.3,1.1-.5l3.2,3.2,1.4-1.4-3.2-3.2ZM4.8,8.5c-.8,0-1.5-.2-2.1-.6,0-1.2,1-2.1,2.1-2,1.1,0,2,.9,2,2,0,0,0,0,0,0-.6.4-1.3.6-2.1.6ZM3.6,4.1c0-.7.5-1.2,1.2-1.2.7,0,1.2.5,1.2,1.2,0,.3-.1.6-.4.8-.2.2-.5.4-.8.4h0c-.7,0-1.2-.5-1.2-1.2ZM7.4,7.5c0-.2,0-.4-.2-.6-.3-.6-.8-1.1-1.4-1.4,0,0,0,0,0,0,.8-.6.9-1.6.4-2.4s-1.6-.9-2.4-.4c-.8.6-.9,1.6-.4,2.4.1.1.2.3.4.4,0,0,0,0,0,0-.8.3-1.4,1.1-1.5,2,0,0,0,0,0,0-.7-.7-1.1-1.6-1.1-2.7s.4-1.9,1.1-2.7,1.6-1.1,2.7-1.1,1.9.4,2.7,1.1,1.1,1.6,1.1,2.7-.4,1.9-1.1,2.7,0,0-.1.1ZM7.8,8.1l.5-.5,2.7,2.7-.5.5-2.7-2.7Z" />
    </svg>
);